import React, { useState } from "react";
import toast from 'react-hot-toast'
import { useForm } from 'react-hook-form'
import DefaultLayout from "../DefaultLayout";
import Loading from "../common/Loading";

const ContactWrapper = () => {
    const { getValues, handleSubmit, formState: { errors }, register } = useForm()
    const [isLoading, setIsLoading] = useState(false)

    const sendContact = async () => {
        setIsLoading(true)
        const contactUrl = 'https://hatchout.co.jp/wp-json/myplugin/v1/myendpoint'
        await fetch(contactUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                companyName: getValues("companyName"),
                fullName: getValues("fullName"),
                phoneNumber: getValues("phoneNumber"),
                email: getValues("email"),
                content: getValues("content"),
            }),
        }).then(resp => resp.json()).then(data => {
            if (data.error) {
                throw new Error(data.error)
            }
            toast.success('お問合せが完了しました。')
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }).catch(err => {
            console.error(err)
            toast.error('お問い合わせに失敗しました。')
        })
        setIsLoading(false)

    }

    // 数字入力の際の上下キーでの変更を無効化
    const handleDisableKeyDown = (e) => {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault();
        }
    };

    // input="number"のマウスホイール操作を無効化
    const onWheelHandler = (e) => {
        e.currentTarget.blur() // マウスホイールでの数値変更を無効化
        e.stopPropagation() // マウスホイール操作の伝搬を防止
    }

    const RequiredBadge = () => <span className="bg-main-800 px-4 py-[calc(3px)] mx-2 text-white text-xs tracking-wider">必須</span>

    return (
        <div className="bg-main-100 py-20" id="contact">
            <DefaultLayout className="px-6">
                <>

                    <h2 className='text-2xl font-semibold mb-8 text-center text-main-800'>
                        お問合せ
                    </h2>

                    <form onSubmit={handleSubmit(sendContact)} className='mb-20 mt-20 max-w-md mx-auto'>

                        <div className="max-w-md">
                            <div className='flex flex-col mb-8'>
                                <label className="mb-2 text-main-800 text-sm" htmlFor="companyName">
                                    御社名<RequiredBadge />
                                </label>
                                <input
                                    className="px-2 py-2 border border-main-400 focus:outline-none transition duration-100 w-full rounded-none"
                                    id='companyName'
                                    {...register('companyName', {
                                        required: '入力をお願いいたします。',
                                    })}
                                />
                                {errors.companyName?.message && <p className="text-red-500 text-sm h-4 ml-1 mt-2">{errors.companyName?.message}</p>}
                            </div>

                            <div className='flex flex-col mb-8'>
                                <label className="mb-2 text-main-800 text-sm" htmlFor="fullName">
                                    氏名<RequiredBadge />
                                </label>
                                <input
                                    className="px-2 py-2 border border-main-400 focus:outline-none transition duration-100 w-full rounded-none"
                                    id='fullName'
                                    {...register('fullName', {
                                        required: '入力をお願いいたします。',
                                    })}
                                />
                                {errors.email?.message && <p className="text-red-500 text-sm h-4 ml-1 mt-2">{errors.fullName?.message}</p>}
                            </div>

                            <div className='flex flex-col mb-8'>
                                <label className="mb-2 text-main-800 text-sm" htmlFor="phoneNumber">
                                    電話番号<RequiredBadge />
                                </label>
                                <input
                                    type="number"
                                    onKeyDown={handleDisableKeyDown}
                                    onWheel={onWheelHandler}
                                    className="px-2 py-2 border border-main-400 focus:outline-none transition duration-100 w-full rounded-none"
                                    placeholder={'例）08012345678'}
                                    {...register('phoneNumber', {
                                        required: '入力をお願いいたします。',
                                        pattern: {
                                            value: /^[0-9]{11}$/, // 海外の場合は4~16桁にする
                                            message: "数字のみの11桁で入力してください。"
                                        }
                                    })}
                                />
                                {errors.email?.message && <p className="text-red-500 text-sm h-4 ml-1 mt-2">{errors.phoneNumber?.message}</p>}
                            </div>

                            <div className='flex flex-col mb-8'>
                                <label className="mb-2 text-main-800 text-sm" htmlFor="email">
                                    メールアドレス<RequiredBadge />
                                </label>
                                <input
                                    className="px-2 py-2 border border-main-400 focus:outline-none transition duration-100 w-full rounded-none"
                                    id='email'
                                    {...register('email', {
                                        required: '入力をお願いいたします。',
                                        pattern: {
                                            value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                                            message: 'メールアドレスの形式で入力をお願いいたします。',
                                        }
                                    })}
                                />
                                {errors.email?.message && <p className="text-red-500 text-sm h-4 ml-1 mt-2">{errors.email?.message}</p>}
                            </div>
                        </div>

                        <div className="flex flex-col mb-2">
                            <label className="w-60 mb-2 text-main-800 text-sm" htmlFor="content">お問い合せ内容<RequiredBadge /></label>
                            <div className="w-full">
                                <textarea
                                    className="p-2 w-full focus:ring-0 focus:outline-none border border-main-400"
                                    rows={6}
                                    {...register('content', {
                                        required: '入力をお願いいたします。',
                                    }
                                    )}
                                />
                                <p className="text-red-500 text-sm h-4 ml-1 mt-2">{errors.content?.message}</p>
                            </div>
                        </div>

                        <div className='flex justify-center'>
                            <button type="submit" onClick={() => { }} className="bg-red-600 text-white py-2 duration-300 hover:opacity-80 !w-48">
                                送信
                            </button>
                        </div>

                    </form>

                    {isLoading && <Loading />}

                </>
            </DefaultLayout>
        </div>
    )
};

export default ContactWrapper